// @flow
import React from 'react';
import { withRouter } from 'react-router';
import { type SectionData } from 'store/modules/common';
import './CategorySectionList.scss';

type Props = {
  sections: ?(SectionData[]),
  history: any,
};

const CategorySectionList = ({ sections, history }: Props) => {
  if (!sections || sections.length === 0) return null;

  const handleSectionClick = (section: SectionData) => {
    if (section.link_type === 'brand') {
      const facets = JSON.stringify({ brand: section.url_slug });
      history.push(`/search?q=&menu=products&facets=${encodeURIComponent(facets)}`);
    } else {
      const facets = JSON.stringify({ categories: section.url_slug });
      history.push(`/search?q=&menu=products&facets=${encodeURIComponent(facets)}`);
    }
  };

  return (
    <div className="CategorySectionList">
      <div className="section-grid">
        {sections.map(section => (
          <div
            key={section.id}
            className="section-item"
            onClick={() => handleSectionClick(section)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleSectionClick(section);
              }
            }}
          >
            <div className="section-image">
              {section.thumbnail ? (
                <img src={section.thumbnail} alt={section.title} />
              ) : (
                <div className="placeholder">
                  <span role="img" aria-label="카테고리">
                    📦
                  </span>
                </div>
              )}
            </div>
            <div className="section-name">{section.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withRouter(CategorySectionList);



// WEBPACK FOOTER //
// ./src/components/categories/CategorySectionList/CategorySectionList.js